/* Footer dropdowns (mobile only) - turns each footer column into an accordion */
(function () {
  var MOBILE = '(max-width: 989px)';

  function columnsOf(root) {
    var row = root;
    var cols = Array.prototype.filter.call(root.children, function (el) {
      return el.classList.contains('group-block');
    });
    var guard = 0;
    while (cols.length === 1 && guard++ < 6) {
      var inner = cols[0].querySelector(':scope > .group-block-content');
      if (!inner) break;
      var next = Array.prototype.filter.call(inner.children, function (el) {
        return el.classList.contains('group-block');
      });
      if (!next.length) break;
      cols = next;
      row = inner;
    }
    if (cols.length < 2) return [];
    row.classList.add('footer-acc-row');
    return cols;
  }

  function build(col) {
    if (col.dataset.footerAcc === 'true') return;

    var content = col.querySelector(':scope > .group-block-content');
    if (!content) return;

    var kids = Array.prototype.slice.call(content.children);
    if (kids.length < 2) return;

    var trigger = kids.shift();
    var panel = document.createElement('div');
    var inner = document.createElement('div');
    panel.className = 'footer-acc__panel';
    inner.className = 'footer-acc__panel-inner';

    var gap = window.getComputedStyle(content).rowGap;
    if (gap && gap !== 'normal') inner.style.setProperty('--footer-acc-gap', gap);

    kids.forEach(function (kid) {
      inner.appendChild(kid);
    });
    panel.appendChild(inner);
    content.appendChild(panel);

    trigger.classList.add('footer-acc__trigger');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-expanded', 'false');

    col.classList.add('footer-acc');
    col.dataset.footerAcc = 'true';

    function toggle() {
      if (!window.matchMedia(MOBILE).matches) return;
      var open = col.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    trigger.addEventListener('click', function (event) {
      if (event.target.closest('a, button, input, select, textarea, form')) return;
      toggle();
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  }

  function init() {
    document.querySelectorAll('.footer-content').forEach(function (root) {
      columnsOf(root).forEach(build);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
